// extracted by mini-css-extract-plugin
export default {"root":"ProductIdentifiersList_root__khwJ6","header":"ProductIdentifiersList_header__gunHx","searchInput":"ProductIdentifiersList_searchInput__SxI0k"};